import { FormControlLabel, Checkbox, Typography, Box } from "@mui/material";

const CheckListOptions = ({
  options,
  selectedFilters,
  setSelectedFilters,
  maxHeight = "auto",
}: {
  options: any[];
  selectedFilters: string[];
  setSelectedFilters: React.Dispatch<React.SetStateAction<string[]>>;
  maxHeight?: string | number;
}) => {
  const handleSelect = (label: string) => {
    setSelectedFilters((prev) =>
      prev.includes(label)
        ? prev.filter((item) => item !== label)
        : [...prev, label]
    );
  };
  return (
    <Box
      sx={{
        maxHeight,
        overflowY: "auto",
      }}
    >
      {options.map(({ label, count }) => (
        <Box
          key={label}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1,
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={selectedFilters.includes(label)}
                onChange={() => handleSelect(label)}
                sx={{
                  color: "#d9d9d9",
                  "&.Mui-checked": {
                    color: "black",
                  },
                }}
              />
            }
            label={label}
          />
          {count && (
            <Typography
              variant="body2"
              sx={{
                backgroundColor: "#f0f0f0",
                px: 1.5,
                py: 0.5,
                borderRadius: "10px",
                fontSize: "0.85rem",
                color: count === 0 ? "gray" : "black",
                opacity: count === 0 ? 0.5 : 1,
              }}
            >
              {count}
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default CheckListOptions;
